import React, { useEffect, useState } from "react";
import Select from "react-select";
import AccountImage from "../AccountImage/AccountImage";

export default function AccountDropdownList({
	accounts,
	onChange = (selectedAccount) => {}, //Callback function when user makes a selection
	selectedAccount, //Set current selected account
	isDisabled = false,
	isLoading = false, //Show loading indicator if needed
}) {
	const [formattedAccounts, setFormattedAccounts] = useState([]);
	const styleWithLeftAlignedText = (provided) => ({ ...provided, textAlign: 'left' });
	const customStyles = {
		option: styleWithLeftAlignedText,
		menu: styleWithLeftAlignedText,
		singleValue: styleWithLeftAlignedText,
	};

	useEffect(() => {
		if (accounts) {
			setFormattedAccounts(
				accounts.map((account) => ({
					value: account.name + account.accountId,
					label: <><AccountImage structuralAccountTypeId={account.structuralAccountTypeId} /> {account.name}</>,
					data: account,
				}))
			);
		}
	}, [accounts]);


	return (
		<Select
			options={formattedAccounts}
			defaultValue={selectedAccount}
			onChange={onChange}
			placeholder="Select an account"
			data-testid="accountSelector"
			isSearchable={true}
			isDisabled={isDisabled}
			isLoading={isLoading}
			styles={customStyles}
		/>
	);
}
